module.exports = __webpack_public_path__ + "images/style-8-3a67bfd1caf8b3d1d9e19162bec21ad1.jpg";